// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IEventTriggerDevice {
	deviceId: string | undefined;

	eventTriggerId: string | undefined;

	$type?: string | undefined;
}
export class EventTriggerDevice {
	constructor(data?: IEventTriggerDevice) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	deviceId: string | undefined;

	eventTriggerId: string | undefined;

	static $type: string = "CoreApi.Models.EventTriggers.EventTriggerDevice, ";
	$type?: string | undefined = EventTriggerDevice.$type;
}

